class RestApi {
	constructor(baseUrl) {
		this.baseUrl = baseUrl;
	}

	encode(s) {
		return encodeURIComponent(s).replaceAll('%20', '+');
	}

	getTabResults(currentTab, mainForm) {
		return this._fetchResults(currentTab + '/results', mainForm);
	}

	_fetchResults(endpoint, mainForm) {
		return fetch(this.baseUrl + endpoint, this._getSettings(mainForm))
			.then(response => {
				if (response.ok) {
					return this._readJson(response);
				}
				if (response.status === 400) {
					throw new Error('Bad request');
				}
				throw new Error('Unknown status code');
			});
	}

	_getSettings(mainForm) {
		return {
			method: 'POST',
			body: this._urlencodeFormData(mainForm),
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		};
	}

	_urlencodeFormData(formElement) {
		const formData = new FormData(formElement);

		let s = '';

		for (const pair of formData.entries()) {
			if (typeof pair[1] === 'string') {
				s += (s ? '&' : '') + this.encode(pair[0]) + '=' + this.encode(pair[1]);
			}
		}

		return s;
	}

	_readJson(response) {
		const contentType = response.headers.get('Content-Type');
		if (contentType && contentType.includes('application/json')) {
			return response.json();
		}

		throw new TypeError('Not a JSON');
	}
}

export default RestApi;
